import EFPicture from 'elem/compCommon/EFPicture';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper';
// import DialogVideo from 'elem/compCommon/DialogVideo';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFVideoModal from '@/components/UI/EFVideoModal';

export default function G() {
    const { useLang, useRouter, useState, useEffect, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('RV');
    const [active, setActive] = useState(0);
    const [swiper, setSwiper] = useState(null);
    const cards = new Array(6).fill(1);
    const [videoSrc, setVideoSrc] = useState('');

    const handleClickTab = (k: number) => {
        setActive(k);
        swiper.slideTo(k);
    };

    const handlePlay = (src: string) => {
        setVideoSrc(src);
    };

    useEffect(() => {
        if (typeof window !== 'undefined' && window.innerWidth < 768) {
            const tabs = document.querySelector('.RV-G .cards .tabs') as HTMLUListElement;
            const { scrollWidth, clientWidth } = tabs;
            if (active >= cards?.length / 2) {
                tabs.scrollLeft = scrollWidth - clientWidth;
            } else {
                tabs.scrollLeft = 0;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [active]);

    return (
        <div id="RV-G" className={`RV-G RV-box ${css['RV-G']}`}>
            <div className="info-box">
                <p className="title">{t('G_title')}</p>
                <p className="desc">{t('G_desc')}</p>
                <div className="videos">
                    <div className="video-link" onClick={() => handlePlay('https://www.youtube.com/embed/6-i-Yq-HhOM?si=5nx_LIErp3OSN-CU')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <circle cx="20.5356" cy="20" r="19" stroke="#3F68E0" strokeWidth="2" />
                            <path d="M16.5356 28.35L30.9106 20.175L16.5356 12V28.35Z" fill="#3F68E0" />
                        </svg>
                        <span className="link-text">{t('G_video1')}</span>
                    </div>
                    <div className="video-link" onClick={() => handlePlay('https://www.youtube.com/embed/IaekVhoMAmo?si=1Px5-DL9hQd6Jia7')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none">
                            <circle cx="20.5356" cy="20" r="19" stroke="#3F68E0" strokeWidth="2" />
                            <path d="M16.5356 28.35L30.9106 20.175L16.5356 12V28.35Z" fill="#3F68E0" />
                        </svg>
                        <span className="link-text">{t('G_video2')}</span>
                    </div>
                </div>
            </div>
            <Swiper
                className="cards swiper-box"
                modules={[Navigation, Pagination]}
                spaceBetween={0}
                slidesPerView={'auto'}
                initialSlide={0}
                pagination={true}
                navigation={true}
                onSlideChange={(swiper) => setActive(swiper?.activeIndex || 0)}
                onSwiper={(swiperIns: any) => setSwiper(swiperIns)}
            >
                <SwiperSlide className="swiper-item">
                    <div className="card-img">
                        <EFPicture src={`https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717078665642/7_1.jpg`} alt={t(`G_card1_text`)} />
                    </div>
                    <p className="card-text">{t(`G_card1_text`)}</p>
                </SwiperSlide>
                <SwiperSlide className="swiper-item">
                    <div className="card-img">
                        <EFPicture src={`https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717078684734/7_2.jpg`} alt={t(`G_card2_text`)} />
                    </div>
                    <p className="card-text">{t(`G_card2_text`)}</p>
                </SwiperSlide>
                <SwiperSlide className="swiper-item">
                    <div className="card-img">
                        <EFPicture src={`https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717078697186/7_3.jpg`} alt={t(`G_card3_text`)} />
                    </div>
                    <p className="card-text">{t(`G_card3_text`)}</p>
                </SwiperSlide>
                <SwiperSlide className="swiper-item">
                    <div className="card-img">
                        <EFPicture src={`https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717078713441/7_4.jpg`} alt={t(`G_card4_text`)} />
                    </div>
                    <p className="card-text">{t(`G_card4_text`)}</p>
                </SwiperSlide>
                <SwiperSlide className="swiper-item">
                    <div className="card-img">
                        <EFPicture src={`https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717078725905/7_5.jpg`} alt={t(`G_card5_text`)} />
                    </div>
                    <p className="card-text">{t(`G_card5_text`)}</p>
                </SwiperSlide>
                <SwiperSlide className="swiper-item">
                    <div className="card-img">
                        <EFPicture src={`https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1717078739411/7_6.jpg`} alt={t(`G_card6_text`)} />
                    </div>
                    <p className="card-text">{t(`G_card6_text`)}</p>
                </SwiperSlide>
                {/* {cards?.map((card: any, k: number) => (
                    <SwiperSlide className="swiper-item" key={k}>
                        <div className="card-img">
                            <EFPicture src={`/responsive/picture/RV/eu/7_${k + 1}.jpg`} alt={t(`G_card${k + 1}_text`)} />
                        </div>
                        <p className="card-text">{t(`G_card${k + 1}_text`)}</p>
                    </SwiperSlide>
                ))} */}
                <ul className="tabs">
                    {cards?.map((tab: any, k: number) => (
                        <li className={`tab ${active === k ? 'active' : ''}`} key={k} onClick={() => handleClickTab(k)}>
                            {t(`G_card${k + 1}_step`)}
                        </li>
                    ))}
                </ul>
            </Swiper>
            {/* {videoSrc && <DialogVideo src={videoSrc} callback={() => setVideoSrc('')} />} */}
            {videoSrc && (
                <EFVideoModal
                    visible={Boolean(videoSrc)}
                    source={videoSrc}
                    onClose={() => setVideoSrc('')}
                    playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
                />
            )}
        </div>
    );
}
